(function () {
    "use strict";

    window.adev = window.adev || {};

    adev.productUpsell = {
        productsData: [],
        init(){
            document.querySelectorAll('[data-adev-product-upsell]:not(.adev-init)').forEach((el) => {
                el.classList.add('adev-init');
                
                const carouselEl = el.querySelector('[data-adev-pu-carousel]');
                const fetchAuto = carouselEl.dataset.adevPuHasProducts !== 'true';

                const url = carouselEl.dataset.productRecommendationsUrl;
                if(fetchAuto){
                    fetch(url)
                    .then(response => response.text())
                    .then(data => {
                        const html = new DOMParser().parseFromString(data, 'text/html');
                        
                        
                        carouselEl.innerHTML = html.querySelector('#shopify-section-adev-product-upsell-auto').innerHTML;
                        this.productsInit(carouselEl);
                        this.carouselInit(carouselEl, el);
                    })
                } else {
                    this.productsInit(carouselEl);
                    this.carouselInit(carouselEl, el);
                }
                
            });
        },
        carouselInit(carouselEl, el){
            const slider = new KeenSlider(
                carouselEl, 
                {
                    slidesPerView: 1,
                    loop: true,
                },
                [
                    slider => {
                        slider.on('created', () => {
                            carouselEl.classList.add('adev-pu-loaded');
                        })
                    }
                ]
            );

            el.querySelector('[data-adev-pu-prev]').addEventListener('click', (e) => {
                e.preventDefault();
                slider.prev();
            })

            el.querySelector('[data-adev-pu-next]').addEventListener('click', (e) => {
                e.preventDefault();
                slider.next();
            })
        },
        productsInit(carouselEl){
            const allProducts = carouselEl.querySelectorAll('[data-adev-pu-item]:not(.adev-init)');
            allProducts.forEach((product) => {
                product.classList.add('adev-init');

                const productId = product.dataset.productId;
                
                const variantsJson = JSON.parse(product.querySelector('[data-adev-pu-variants-json]').innerHTML);
                const image = product.querySelector('[data-adev-pu-image]');
                const prices = product.querySelector('[data-adev-pu-prices]');
                const compareAtPrice = product.querySelector('[data-adev-pu-cap]');
                const regularPrice = product.querySelector('[data-adev-pu-rp]');
                const select = product.querySelector('[data-adev-pu-select]');
                const addToCart = product.querySelector('[data-adev-pu-add]');

                this.productsData[productId] = this.productsData[productId] || {};
                this.productsData[productId].variantsData = variantsJson;
                this.productsData[productId].currentVariant = this.productsData[productId].variantsData.find(variant => variant.id === parseInt(select.value));

                select.addEventListener('change', () => {
                    this.productsData[productId].currentVariant = this.productsData[productId].variantsData.find(variant => variant.id === parseInt(select.value));

                    const currentVariant = this.productsData[productId].currentVariant;

                    const onSale = currentVariant.compare_at_price > currentVariant.price;
                    
                    prices.setAttribute('data-available', currentVariant.available ? 'true' : 'false');
                    prices.setAttribute('data-on-sale', onSale ? 'true' : 'false');

                    compareAtPrice.querySelector('s').innerHTML = onSale ? Shopify.formatMoney(currentVariant.compare_at_price) : '';
                    regularPrice.innerHTML = Shopify.formatMoney(currentVariant.price);

                    
                    addToCart.disabled = !currentVariant.available;

                    if(currentVariant.featured_image !== null) {
                        image.src = "function" == typeof Shopify.Image.getSizedImageUrl ? Shopify.Image.getSizedImageUrl(currentVariant.featured_image.src, "350x") : currentVariant.featured_image.src;
                    }
                });

                
                addToCart.addEventListener('click', (e) => {
                    e.preventDefault();
                    const currentVariant = this.productsData[productId].currentVariant;
                    if(!currentVariant.available) return;

                    addToCart.disabled = true;
                    const formData = new FormData();
                    formData.append('quantity', 1);
                    formData.append('id', currentVariant.id);

                    fetch('/cart/add.js', {
                        method: 'POST',
                        body: formData
                    })
                    .then(response => response.json())
                    .then(data => {
                        addToCart.disabled = false;

                        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
                            bubbles: true,
                        }));

                    })
                    .catch((error) => {
                        addToCart.disabled = false;
                        console.error('Error:', error);
                    });

                });
                
            });
        }
    };

    adev.productUpsell.init();

}());